import { INotificationSettingsSchema, IUser } from 'bg-server/src/components/api/v1/user/types';

import { ENV } from 'src/config/environments';
import { httpRequest } from 'src/helpers/http';

class SettingsService {
    private getApiEndpoint(): string {
        const selectedCity = localStorage.getItem('selectedCity') || ENV.apiEndpoints[0].key;
        const apiEndpoint = ENV.apiEndpoints.find(endpoint => endpoint.key === selectedCity);
        return apiEndpoint ? `${apiEndpoint.url}/user` : `${ENV.apiEndpoints[0].url}/user`;
    }

    public async updateSetting(data: INotificationSettingsSchema): Promise<IUser> {
        const response = await httpRequest(`${this.getApiEndpoint()}/update-settings`, 'POST', data);
        const json = await response.json();
        if (json.error !== undefined) {
            await Promise.reject(json.message);
        }
        return json;
    }
}

export const settingsService = new SettingsService();
